import { Actions } from '.'
import { Urls } from '../../constants'
import { ReduxApiGet } from './Helpers'

export const GetAllFeatureFlagsAction = () => ReduxApiGet(Urls.featureFlags.getAll(), Actions.FeatureFlags.GetAll)
    .withMutex()
    .useStored(s => s.featureFlags.all.data, 'feature-flags', 30)
    .run()
